const formatToDecimal = (value: number) => {
  return process.browser
    ? new Intl.NumberFormat('en-AU', {
        maximumSignificantDigits: 3,
      }).format(value)
    : value;
};
export default formatToDecimal;
